import React from 'react';
import styled from '../../../../styled';
import dayjs, { TODAY } from '../day';
import { ColumnButton } from './Column';
const Container = styled.div `
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;
const MonthColumn = styled(ColumnButton) `
  width: 4.5625rem;
  height: 1.75rem;
  margin: 0.5rem 0;
`;
const MonthCalendarView = ({ lang, target, selectedDate, selectedFrom, selectedTo, onSelect, disabledDate, }) => {
    const months = new Array(12).fill(null).map((_, i) => i);
    return (React.createElement(Container, null, months.map((month) => {
        const targetMonth = target.month(month);
        const isThisMonth = targetMonth.isSame(TODAY, 'month');
        const from = selectedFrom || selectedDate;
        const to = selectedTo || selectedDate;
        const isPeriod = from &&
            to &&
            targetMonth.isBetween(from, to, 'month', '[]');
        const isSelected = !!selectedDate && targetMonth.isSame(selectedDate, 'month');
        const isFromSelected = from && targetMonth.isSame(from, 'month');
        const isToSelected = to && targetMonth.isSame(to, 'month');
        const isDisabled = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(targetMonth.toDate());
        return (React.createElement(MonthColumn, { key: targetMonth.toString(), isDefault: isThisMonth, isSelected: isSelected, isFromSelected: isFromSelected, isToSelected: isToSelected, isPeriod: isPeriod, onClick: () => !isDisabled && onSelect(month), isDisabled: isDisabled }, dayjs(lang, targetMonth).format('MMM')));
    })));
};
export default MonthCalendarView;
//# sourceMappingURL=MonthCalendarView.js.map